import { createAction } from '@reduxjs/toolkit';
export const LOG_CALL_CRM = 'LOG_CALL_CRM';
export const logCallCRMAction = createAction(LOG_CALL_CRM);